import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Paginator } from 'primereact/paginator'
import ExcelExportButton from '../../components/ui/ExcelExportButton'
import PageHeader from '../../components/ui/PageHeader'
import Button from '../../components/ui/Button'
import MeetingList from './components/MeetingList'
import { useSetBreadcrumb } from '../../app/nav/breadcrumb'
import { useNavigateWithOrigin } from '../../app/nav/originNav'
import { exportDraftMeetings } from './api/meetingApi'
import { useDraftMeetings } from './hooks/useDraftMeetings'
import './meetings.css'

const PAGE_SIZE = 20

/**
 * <b>Taslaklar</b> (2026-07-30 analist kararı) — tüm gruplardaki taslak (360) tutanaklar. Toplantılar
 * ekranındaki "Taslaklar" kartından gelinir; grup kartları/drill-down yalnız yayınlanmışları gösterir.
 * Satır → Toplantı Detay: taslak düzenlenebilir, tamamlanıp <b>Yayınla</b> ile 361'e geçirilir; yayınlanan
 * kayıt bu listeden düşer ve grubunun listesinde belirir. Rota: /minutes/meeting-minutes/meetings/drafts.
 */
export default function DraftMeetingsPage() {
  const { t } = useTranslation()
  // Detaya giderken Taslaklar listesi origin taşınır → Toplantı Detay'da "Geri" buraya döner.
  const goDetail = useNavigateWithOrigin()
  const navigate = useNavigate()
  const [page, setPage] = useState(0)

  const drafts = useDraftMeetings(page, PAGE_SIZE)
  const total = drafts.data?.page.totalElements ?? 0

  // Header breadcrumb'ına ek adım: Taslaklar. "Toplantılar" adımı menüden otomatik gelir.
  useSetBreadcrumb([{ label: t('meetings.drafts.title') }])

  return (
    <div className="page meetings-page">
      <PageHeader
        title={t('meetings.drafts.title')}
        actions={
          <>
            <ExcelExportButton
              onExport={exportDraftMeetings}
              disabled={(drafts.data?.content ?? []).length === 0}
            />
            {/* Taslaklar da Toplantılar grid'indeki karttan açılır → grup listesiyle aynı dönüş butonu. */}
            <Button
              variant="secondary"
              icon="pi pi-arrow-left"
              label={t('meetings.backToGroups')}
              onClick={() => navigate('/minutes/meeting-minutes/meetings')}
            />
          </>
        }
      />
      <MeetingList
        items={drafts.data?.content ?? []}
        loading={drafts.isLoading}
        onSelect={(id) => goDetail(`/minutes/meeting-minutes/meetings/${id}`)}
        showGroup
        emptyTitle={t('meetings.drafts.empty.title')}
        emptyDesc={t('meetings.drafts.empty.desc')}
      />
      {total > PAGE_SIZE && (
        <Paginator
          first={page * PAGE_SIZE}
          rows={PAGE_SIZE}
          totalRecords={total}
          onPageChange={(e) => setPage(e.page)}
        />
      )}
    </div>
  )
}
